// extracted by mini-css-extract-plugin
module.exports = {"moreResults":"More_moreResults__22E4u","moreLabel":"More_moreLabel__1MG-Z"};